import axios from 'axios';

const getNotasFiscais = params => axios.get('/notas-fiscais', {
  params,
});

const getNotaFiscal = id => axios.get(`/notas-fiscais/${id}`);

const getDanfe = id => axios.get(`/notas-fiscais/${id}/danfe`);

const getXml = id => axios.get(`/notas-fiscais/${id}/xml`);

export default {
  getNotaFiscal,
  getNotasFiscais,
  getDanfe,
  getXml,
};
